import { Carregamento } from '@digix-ui/componentes'
import clsx from 'clsx'

import { MenuItem } from '@/components/global/MenuItem'
import SubCabecalho from '@/components/global/SubCabecalho'
import { useAuth } from '@/hooks'

import classes from './styles.module.scss'

import type { LayoutComMenuLateralProps } from './tipos'

export function LayoutComMenuLateral({
  subCabecalho,
  subPaginas,
  carregando,
  children,
}: LayoutComMenuLateralProps): JSX.Element {
  const contextoAutenticacao = useAuth()

  const paginasPermitidas = subPaginas.filter(pagina => {
    if (pagina.permissoesNecessarias.length === 0) return true

    return pagina.permissoesNecessarias?.every(
      permissao =>
        contextoAutenticacao?.[
          permissao as keyof typeof contextoAutenticacao
        ] === true
    )
  })

  return (
    <>
      {carregando && <Carregamento telaCheia />}
      {subCabecalho && (
        <SubCabecalho
          titulo={subCabecalho.titulo}
          voltar={subCabecalho.voltar}
        />
      )}
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <nav className={classes.menuItems}>
            {paginasPermitidas.map(pagina => (
              <MenuItem
                key={`sub-pagina-${pagina.id}`}
                id={pagina.id}
                icone={pagina.icone}
                iconeDireita="fa-regular fa-chevron-right"
                label={pagina.nome}
                irPara={pagina.path}
              />
            ))}
          </nav>

          <div className={clsx('cartao', classes.container)}>{children}</div>
        </div>
      </div>
    </>
  )
}
